"use strict";

angular.module("core")
.component("sortBy", {
    templateUrl: require("./sort-by.component.html"),
    controller: SortByController,
    controllerAs: "sortByCtrl",
    bindings: {
        service: "<",
        onChange: "<?",
        defaultValue: "@?",
        defaultText: "<"
    }
});

function SortByController($rootScope, $scope, $stateParams, StateExtensionService) {
    var _this = this;
    _this.sortFields = {};

    function getSortFilterName(data, ordering) {
        return data["name"] + ": " + data[ordering];
    }

    function setSorts() {
        var fields = _this.service.getSortFields();
        Object.keys(fields).forEach(function(key, index) {
            var filterData = fields[key];
            _this.sortFields[key] = {
                Value: key,
                Name: getSortFilterName(filterData, "normal")
            };
            _this.sortFields["reverse" + key] = {
                Value: "-" + key,
                Name: getSortFilterName(filterData, "reverse")
            };
        });

        if (!_this.orderingValue && _this.defaultValue) {
            _this.orderingValue = _this.defaultValue;
            updateStateParams();
        }
    }

    if ($stateParams.ordering) {
        this.orderingValue = $stateParams.ordering;
    }

    setSorts();

    var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        setSorts();
    });

    this.$onDestroy = function() {
        unregisterLanguageChanged();
    };

    this.executeSort = function() {
        updateStateParams();
        if (this.onChange) {
            this.onChange(this.orderingValue);
        }
        $scope.$emit("queryListing", {ordering: this.orderingValue});

    };

    function updateStateParams() {
        StateExtensionService.updateUrlParams({ordering: _this.orderingValue});
    }

}



//////////////////
// WEBPACK FOOTER
// ./core/sort-by/sort-by.component.js
// module id = 590
// module chunks = 0